import { apiGet } from "../Utils/axios";

export function getDateDataAPI() {
    return apiGet({ endPoint: 'transactionCounter' });
}